define([
	"dojo/_base/declare",
	"csi/heading/NumberController",
	"csi/xml",
	"ProductSpec/SizeChart"
], function(declare,NumberController,xml,SizeChart) {

    return declare(NumberController, {
		_fromHtmlDynamic: function() {
			// summary: extract new value from edit node
			var	value = this.inherited(arguments);
			return ((value > 0) && !this._isPositiveValue()) ? -value : value;
		},

		_toWriterValue: function(/*String*/id, /*String*/type) {
			// summary: determine if positive tolerance needs to be changed as well
			var	cn = this.inherited(arguments);

            // only set the positive tolerance, if
            // it is currently 0
            // the negative tolerance is not blank
			var toleranceAttrName = (this.heading.m_id == "InspectionToleranceNegative" ? "InspectionTolerance" : "Tolerance");
			if (!SizeChart.isNotInitialized(this.newValue) && xml.nodeGetAttributeValue(this.getNode(), toleranceAttrName) == 0) {
				cn.changeAttribute(toleranceAttrName, xml.ATTR_DOUBLE, -this.newValue);
				this.bRefreshNode = true;
			}

			return cn;
		}
	});
});